import React, {useEffect, useMemo, useState} from 'react'
import {useNavigate} from 'react-router-dom'
import Swal from 'sweetalert2'
import {useIntl} from 'react-intl'

import {
  DataFilterModel,
  FilterModel,
  RegistroContactenos,
  RegistroOrgVentasxLocales,
  RegistroReclamaciones,
} from '../../models/_models'
import {useThemeMode} from '../../../../../_metronic/partials'
import {
  findAllContactenos,
  findAllEstatus,
  findAllOrgVByLocal,
  findAllReclamaciones,
  removeContactenos,
  removeReclamaciones,
} from '../../models/_requests'
import {KTSVG} from '../../../../../_metronic/helpers'

import FilterModal from '../../Modal/FilterModal'
import {DateFormat, getNodoByNivel} from '../../models/helpers'
import {RegistroFuncionalidad, useAuth} from '../../../auth'
import dayjs from 'dayjs'
import ColumnDropdownReclamaciones from './Components/ColumnDropdownReclamaciones'
import {columnasReclamaciones} from './Components/columnasReclamaciones'
import {AdvancedTable} from '../../../widgets/TablesComponents/AdvancedTable'
import { set } from 'date-fns'

type Props = {
  className: string
}

const TablesReclamaciones: React.FC<Props> = ({className}) => {
  const navigate = useNavigate()
  const [data, setData] = useState<RegistroReclamaciones[]>([])
  const [orgVByLocal, setOrgVByLocal] = useState<RegistroOrgVentasxLocales[]>([])
  const [estado, setEstado] = useState(false)
  const [loading, setLoading] = useState(false)
  const [view, setView] = useState(false)
  const {mode} = useThemeMode()
  const {currentUser} = useAuth()

  const [showFilter, setShowFilter] = useState(false)
  const [idFilter, setIdFilter] = useState('')
  const [nombreFilter, setNombreFilter] = useState('')
  const [apellidoFilter, setApellidoFilter] = useState('')
  //   const [celularFilter, setCelularFilter] = useState('')
  //   const [emailFilter, setEmailFilter] = useState('')
  //   const [mensajeFilter, setMensajeFilter] = useState('')
  const [estadoFilter, setEstadoFilter] = useState('')

  //Campos nuevos
  const [tipoReclamoFilter, setTipoReclamoFilter] = useState('')
  const [montoReclamoFilter, setMontoReclamoFilter] = useState('')
  const [numeroDocumentoFilter, setNumeroDocumentoFilter] = useState('')
  const [sedeFilter, setSedeFilter] = useState('')
  const[tipoBienContratadoFilter,setTipoBienContratadoFilter]=useState('')
  const[FechaIncidenciaFilter,setFechaIncidenciaFilter]=useState('')
  const[FechaRespuestaFilter,setFechaRespuestaFilter]=useState('')
  
  
  const[tipoDocumentoFilter,setTipoDocumentoFilter]=useState('')
  
  //Campos nuevos

  const [activoFilter, setActivoFilter] = useState('')

  const [creadoPorFilter, setCreadoPorFilter] = useState('')
  const [creadoElFilter, setCreadoElFilter] = useState('')
  const [modificadoPorFilter, setModificadoPorFilter] = useState('')
  const [modificadoElFilter, setModificadoElFilter] = useState('')

  const [cantidadFilter, setCantidadFilter] = useState(200)

  const [tituloModal, setTituloModal] = useState('')
  const [filterSelect, setFilterSelect] = useState('')
  const [filterInput, setFilterInput] = useState('')
  const [filterInput2, setFilterInput2] = useState('')
  const [tipoInput, setTipoInput] = useState('')
  const [options, setOptions] = useState<{value: string; label: string}[]>([])
  const [column, setColumn] = useState('')
  const intl = useIntl()

  const [filters, setFilters] = useState<FilterModel[]>([
    {
      campo: 'IdOrgV',
      operador: 'EQ',
      tipo: 'string',
      valor1: currentUser ? currentUser.registro.IdOrgV : '',
      valor2: '',
    },
  ])

   const [dataOrgVXLocal, setDataOrgVXLocal] = useState<DataFilterModel[]>([])

  const getOrgVXLocal = async() => {
    
        const body = {
          IdOrgV: currentUser ? currentUser.registro.IdOrgV : '',
      }

      try {
        const {data: org} = await findAllOrgVByLocal(body)
        if (org.message.msgId == 0) {
          const newData: DataFilterModel[] = org.registro.map((item) => ({
            id: Number(item.IdOrgVxLocal),
            descripcion: item.Sede,
          }))
          setDataOrgVXLocal([{id: 0, descripcion: 'Seleccione una sede'}, ...newData])
        } else {
          setDataOrgVXLocal([{id: 0, descripcion: 'Seleccione una sede'}])
        }
      } catch (error) {
        console.error(error)
      }
  }


  const getData = async () => {
    setLoading(true)

    const filters = {
      cantidad_max: '0',
      Language: 'ES',
      filters: [ ],
    }

    try {
      const {data: list} = await findAllReclamaciones(filters,currentUser ? currentUser.registro.IdOrgV : '')
      if (list.message.msgId == 0) {
        setData(list.registro)
      } else {
        setData([])
      }
    } catch (error) {
      console.error(error)
    }
    setLoading(false)
  }

  const handleCreate = () => {
    setTimeout(() => {
      const direccion = `/menu/administracion/reclamaciones/create`
      navigate(direccion)
    }, 1000)
  }

  const handleView = (id: number) => {
    setTimeout(() => {
      const direccion = `/menu/administracion/reclamaciones/view`
      navigate(direccion, {
        state: {
          id_reclamaciones: id,
        },
      })
    }, 1000)
  }

  const handleDelete = async (id: number, descripcion: string) => {
    Swal.fire({
      title: 'Estas seguro(a)?',
      text: `Se eliminará el registro: ${descripcion} !`,
      icon: 'warning',

      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, Eliminar!',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const {data: remove} = await removeReclamaciones(id)
          if (remove.message.msgId == 0) {
            setEstado(!estado)

            Swal.fire({
              icon: 'success',
              title: 'Eliminado!',
              text: `${remove.message.msgTxt}`,

              timer: 3000,
            })
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Oops... Ocurrio un error',
              text: `${remove.message.msgTxt}`,

              timer: 3000,
            })
          }
        } catch (error) {
          console.log('No se pudo eliminar')
          console.error(error)
        }
      }
    })
  }

  const handleViewDiv = () => {
    setView(!view)
  }

  const limpiarInputs = () => {
    setIdFilter('')
    setNombreFilter('')
    setApellidoFilter('')
    // setCelularFilter('')
    // setEmailFilter('')
    // setMensajeFilter('')
    setEstadoFilter('')


    //Campos nuevos
    setTipoReclamoFilter('')
    setMontoReclamoFilter('')
    setNumeroDocumentoFilter('')
    setSedeFilter('')
    setTipoDocumentoFilter('')
    setTipoBienContratadoFilter('')
    setFechaIncidenciaFilter('')
    setFechaRespuestaFilter('')
    //Campos nuevos

    setActivoFilter('')

    setCreadoPorFilter('')
    setCreadoElFilter('')
    setModificadoPorFilter('')
    setModificadoElFilter('')

    setCantidadFilter(300)
  }

  const [contadorFiltro, setContadorFiltro] = useState(0)

  const limpiarFiltros = () => {
    setFilters([
      {
        campo: '',
        operador: '',
        tipo: '',
        valor1: '',
        valor2: '',
      },
    ])
    localStorage.removeItem('filtrosReclamaciones')
    limpiarInputs()
    setContadorFiltro(contadorFiltro + 1)
  }

  const handleShowFilter = (titulo: string, tipoInput: string, dato: string) => {
    setTituloModal(titulo)
    setTipoInput(tipoInput)
    setShowFilter(true)
    setColumn(dato)

    if (tipoInput === 'text') {
      setOptions([
        {value: '', label: 'Seleccione una condición'},
        {value: 'EQ', label: 'Igual a'},
        {value: 'Contains', label: 'Contiene a'},
      ])
    } else if (tipoInput === 'date' || tipoInput === 'number') {
      setOptions([
        {value: '', label: 'Seleccione una condición'},
        {value: 'EQ', label: 'Igual a'},
        {value: 'GT', label: 'Mayor que'},
        {value: 'GE', label: 'Mayor que o igual a'},
        {value: 'LT', label: 'Menor que'},
        {value: 'LE', label: 'Menor que o igual a'},
        {value: 'BT', label: 'Entre'},
      ])
    } else if (tipoInput === 'textSelect' || tipoInput === 'numberSelect') {
      setOptions([
        {value: '', label: 'Seleccione una condición'},
        {value: 'EQ', label: 'Igual a'},
      ])
      setTipoInput(tipoInput === 'textSelect' ? 'text' : 'number')
    } else {
      setOptions([
        {value: '', label: 'Seleccione una condición'},
        {value: 'EQ', label: 'Igual a'},
      ])
    }
  }

  const handleCloseFilter = () => {
    setShowFilter(false)
  }

  const mostrarInputs = (selectValue: string, inputValue: string) => {
    switch (column) {
      case 'IdReclamacion':
        setIdFilter(selectValue + ': ' + inputValue)
        break

      case 'Nombres':
        setNombreFilter(selectValue + ': ' + inputValue)
        break

      case 'Apellidos':
        setApellidoFilter(selectValue + ': ' + inputValue)
        break

      


      //   case 'Celular':
      //     setCelularFilter(selectValue + ': ' + inputValue)
      //     break

      //   case 'Email':
      //     setEmailFilter(selectValue + ': ' + inputValue)
      //     break
      //   case 'Mensaje':
      //     setMensajeFilter(selectValue + ': ' + inputValue)
      //     break
      case 'IdEstatus':
        setEstadoFilter(selectValue + ': ' + inputValue)
        break

      case 'TipoReclamo':
        setTipoReclamoFilter(selectValue + ': ' + inputValue)
        break

      case 'MontoReclamo':
        setMontoReclamoFilter(selectValue + ': ' + inputValue)
        break
      
      case 'IdOrgVxLocal':
        setSedeFilter(selectValue + ': ' + inputValue)
        break

      case 'TipoDocumento':
         setTipoDocumentoFilter(selectValue + ': ' + inputValue)
        break
      
        case 'TipoBienContratado':
         setTipoBienContratadoFilter(selectValue + ': ' + inputValue)
        break

      case 'NumDocumento':
        setNumeroDocumentoFilter(selectValue + ': ' + inputValue)
        break

      case 'Activo':
        setActivoFilter(selectValue + ': ' + inputValue)
        break

      case 'FechaIncidencia':
        setFechaIncidenciaFilter(selectValue + ': ' + inputValue)
        break
      
      case 'FechaRespuesta':
        setFechaRespuestaFilter(selectValue + ': ' + inputValue)
        break

      case 'CreadoPor':
        setCreadoPorFilter(selectValue + ': ' + inputValue)
        break

      case 'CreadoEl':
        setCreadoElFilter(selectValue + ': ' + inputValue)
        break

      case 'ModificadoPor':
        setModificadoPorFilter(selectValue + ': ' + inputValue)
        break

      case 'ModificadoEl':
        setModificadoElFilter(selectValue + ': ' + inputValue)
        break
    }
  }

  const mostrarInputsInicial = (
    selectValue: string,
    inputValue: string | number,
    columna: string
  ) => {
    switch (columna) {
      case 'IdReclamacion':
        setIdFilter(selectValue + ': ' + inputValue)
        break

      case 'Nombres':
        setNombreFilter(selectValue + ': ' + inputValue)
        break

      case 'Apellidos':
        setApellidoFilter(selectValue + ': ' + inputValue)
        break

      //   case 'Celular':
      //     setCelularFilter(selectValue + ': ' + inputValue)
      //     break

      //   case 'Email':
      //     setEmailFilter(selectValue + ': ' + inputValue)
      //     break
      //   case 'Mensaje':
      //     setMensajeFilter(selectValue + ': ' + inputValue)
      //     break

      case 'IdEstatus':
        setEstadoFilter(selectValue + ': ' + inputValue)
        break

      case 'TipoReclamo':
        setTipoReclamoFilter(selectValue + ': ' + inputValue)
        break

      case 'MontoReclamo':
        setMontoReclamoFilter(selectValue + ': ' + inputValue)
        break

      case 'NumDocumento':
        setNumeroDocumentoFilter(selectValue + ': ' + inputValue)
        break

      case 'TipoDocumento':
         setTipoDocumentoFilter(selectValue + ': ' + inputValue)
        break
      
        case 'TipoBienContratado':
         setTipoBienContratadoFilter(selectValue + ': ' + inputValue)
        break

      case 'IdOrgVxLocal':
        setSedeFilter(selectValue + ': ' + inputValue)
        break

      case 'Activo':
        setActivoFilter(selectValue + ': ' + inputValue)
        break

      case 'FechaIncidencia':
        setFechaIncidenciaFilter(selectValue + ': ' + inputValue)
        break
      
      case 'FechaRespuesta':
        setFechaRespuestaFilter(selectValue + ': ' + inputValue)
        break


      case 'CreadoPor':
        setCreadoPorFilter(selectValue + ': ' + inputValue)
        break

      case 'CreadoEl':
        setCreadoElFilter(selectValue + ': ' + inputValue)
        break

      case 'ModificadoPor':
        setModificadoPorFilter(selectValue + ': ' + inputValue)
        break

      case 'ModificadoEl':
        setModificadoElFilter(selectValue + ': ' + inputValue)
        break
    }
  }

  const handleAplicarFilter = (
    selectValue: string,
    inputValue: string,
    input2Value: string,
    descripcionValue: string,
    descripcion2Value: string
  ) => {
    const existingFilterIndex = filters.findIndex((filter) => filter.campo === column)

    let updatedFilters: FilterModel[] = [
      {
        campo: 'IdOrgV',
        operador: 'EQ',
        tipo: 'string',
        valor1: currentUser ? currentUser.registro.IdOrgV : '',
        valor2: '',
      },
    ]

     // 🕒 👉 Si el filtro es de fecha, convertir a formato ISO
  // let value1 = inputValue
  // let value2 = input2Value
  // console.log(column)
  // console.log(inputValue)
  // console.log(input2Value)
  // if (column === 'FechaIncidencia' || column === 'FechaRespuesta') {
  //   if (inputValue) {
  //     value1 = new Date(inputValue).toISOString()
  //   }
  //   if (input2Value) {
  //     value2 = new Date(input2Value).toISOString()
  //   }
  // }

  // console.log(value1)
  // console.log(value2)

    if (existingFilterIndex !== -1) {
      updatedFilters = [...filters]
      updatedFilters[existingFilterIndex] = {
        ...updatedFilters[existingFilterIndex],
        operador: selectValue,
        valor1: inputValue,
        valor2: input2Value,
        descripcion1: descripcionValue,
        descripcion2: descripcion2Value,
        tipo:
          tipoInput === 'text'
            ? 'string'
            : tipoInput === 'number'
            ? 'numeric2'
            : tipoInput === 'date'
            ? 'date'
            : tipoInput === 'boolean'
            ? 'boolean'
            : '',
      }
    } else {
      const newFilter: FilterModel = {
        campo: column,
        operador: selectValue,
        valor1: inputValue,
        valor2: input2Value,
        descripcion1: descripcionValue,
        descripcion2: descripcion2Value,
        tipo:
          tipoInput === 'text'
            ? 'string'
            : tipoInput === 'number'
            ? 'numeric2'
            : tipoInput === 'date'
            ? 'date'
            : tipoInput === 'boolean'
            ? 'boolean'
            : '',
      }
      updatedFilters = [...filters, newFilter]
    }

    // 🧹 Limpieza final: eliminar filtros vacíos o sin valor1
  const filtrosLimpios = updatedFilters.filter(
    (f) => f.campo && f.operador && f.valor1
  );

  // ✅ Guardar solo filtros válidos
  setFilters(filtrosLimpios);
  localStorage.setItem('filtrosReclamaciones', JSON.stringify(filtrosLimpios));

    setFilterSelect(selectValue)
    setFilterInput(inputValue)
    setFilterInput2(input2Value)

    mostrarInputs(
      selectValue,
      descripcion2Value.trim() === ''
        ? descripcionValue
        : `${descripcionValue} - ${descripcion2Value}`
    )
    setShowFilter(false)
  }

  const handleFilterClick = async () => {
    setLoading(true)
    const options = {
      cantidad_max: cantidadFilter.toString(),
      Language: intl.locale.toUpperCase(),
      filters: filters.map((filter) => ({
        campo: filter.campo,
        operador: filter.operador,
        tipo: filter.tipo,
        valor1: filter.valor1,
        valor2: filter.valor2,
      })),
    }

    try {
      const {data: list} = await findAllReclamaciones(options,currentUser ? currentUser.registro.IdOrgV : '')
      setData(list.registro)

      setLoading(false)
    } catch (error) {
      console.error(error)
        setData([])  // 👈 AGREGA ESTO para manejar errores

    }
  }

  useEffect(() => {
    const storedFilters = localStorage.getItem('filtrosReclamaciones')

    if (storedFilters) {
      const parsedFilters = JSON.parse(storedFilters)

      parsedFilters.map((filter: FilterModel) => {
        mostrarInputsInicial(
          filter.operador,
          (filter.descripcion2?.trim() === ''
            ? filter.descripcion1
            : `${filter.descripcion1 ?? ''} - ${filter.descripcion2 ?? ''}`) ?? '',
          filter.campo
        )
      })

      setFilters(parsedFilters)
    } else {
      setFilters([])
    }

    setContadorFiltro(contadorFiltro + 1)
  }, [])

  const [isDataLoaded, setIsDataLoaded] = useState(false)

  useEffect(() => {
    if (contadorFiltro > 0) {
      if (filters && filters.length > 0) {
        handleFilterClick()
      } else {
        getData()
      }
      setIsDataLoaded(true)
    }
  }, [estado, contadorFiltro])

  const dataActivo = [
    {id: '', descripcion: 'Seleccione activo '},
    {id: true, descripcion: 'Si'},
    {id: false, descripcion: 'No'},
  ]

  const dataTipoDocumento= [
    {id: '', descripcion: 'Seleccione tipo de documento '},
    {id: 'DNI', descripcion: 'DNI'},
    {id: 'Carnet de Extranjería', descripcion: 'Carnet de Extranjería'},
  ]

  const dataTipoBienContratado = [
    {id: '', descripcion: 'Seleccione tipo de bien contratado'},
    {id: 'Producto', descripcion: 'Producto'},
    {id: 'Servicio', descripcion: 'Servicio'},
  ]

  const dataTipoReclamo = [
    {id: '', descripcion: 'Seleccione tipo de reclamo'},
    {id: 'Reclamo', descripcion: 'Reclamo'},
    {id: 'Queja', descripcion: 'Queja'},
  ]

  const [dataEstatus, setDataEstatus] = useState<DataFilterModel[]>([])

  const getDataEstatus = async () => {
    const value = {
      cantidad_max: '0',
      Language: intl.locale.toUpperCase(),
      filters: [
        {
          campo: 'IdEsquemaEstatus',
          operador: 'EQ',
          tipo: 'string',
          valor1: '2',
          valor2: '',
        },
      ],
    }

    try {
      const {data: list} = await findAllEstatus(value)

      if (list.message.msgId == 0) {
        const newData: DataFilterModel[] = list.registro.map((item) => ({
          id: Number(item.IdEstatus),
          descripcion: item.Descripcion,
        }))
        setDataEstatus([{id: 0, descripcion: 'Seleccione un estatus'}, ...newData])
      } else {
        setDataEstatus([{id: 0, descripcion: 'Seleccione un estatus'}])
      }
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    if (isDataLoaded) {
      getDataEstatus()
      getOrgVXLocal()
    }
  }, [isDataLoaded])

  const [registroFuncionalidad, setRegistroFuncionalidad] = useState<RegistroFuncionalidad | null>(
    null
  )

  const funcionalidad = getNodoByNivel(12, 0, currentUser)

  useEffect(() => {
    if (funcionalidad) {
      console.log(funcionalidad)
      setRegistroFuncionalidad(funcionalidad)
    }
  }, [funcionalidad])

  const handleRefresh = () => {
    getData()
  }

  //

  const [error, setError] = useState('')
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(5)

  const [visibleColumnKeys, setVisibleColumnKeys] = useState<string[]>([])

  const defaultVisibleColumns: (keyof RegistroReclamaciones | string)[] = [
    'IdReclamo',
    'Nombres',
    'Apellidos',
    'NumDocumento',
    'TipoReclamo',
    'MontoReclamo',
    'estatus.Descripcion',
    // 'Email',
    // 'Celular',
    // 'Mensaje',
    'Activo',
  ]

  useEffect(() => {
    const stored = localStorage.getItem('columnasReclamaciones')
    if (stored) {
      setVisibleColumnKeys(JSON.parse(stored))
    } else {
      setVisibleColumnKeys(defaultVisibleColumns)
    }
  }, [])

  const toggleColumn = (key: string) => {
    setVisibleColumnKeys((prev) => {
      const updated = prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
      localStorage.setItem('columnasReclamaciones', JSON.stringify(updated))
      return updated
    })
  }

  useEffect(() => {
    const total = Math.ceil(data.length / rowsPerPage)
    setTotalPages(total || 1)
  }, [data, rowsPerPage])


  return (
    <div className={`card ${className}`}>
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>
            {intl.formatMessage({id: 'CLAIMS_LIST'})}
          </span>
        </h3>

        <div className='card-toolbar'>
          <a
            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
            onClick={handleRefresh}
          >
            <i className='fas fa-arrow-rotate-right svg-icon-3'></i>
          </a>

          <a
            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
            onClick={handleViewDiv}
          >
            <i className='bi bi-funnel-fill'></i>
          </a>

          {registroFuncionalidad?.Crear && (
            <a className='btn btn-sm btn-light-primary' onClick={handleCreate}>
              <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
              {intl.formatMessage({id: 'CLAIMS_NEW'})}
            </a>
          )}

          <ColumnDropdownReclamaciones
            columns={columnasReclamaciones}
            visibleColumnKeys={visibleColumnKeys}
            toggleColumn={toggleColumn}
          />
        </div>
      </div>

      {view && (
        <div className='mx-14 border-0 pt-1'>
          <div className='row'>
            <div className='py-0 col-3'>
              <label className='col-form-label fw-bold fs-6'>Id:</label>
              <div className='d-flex'>
                <input
                  type='text'
                  className={`form-control ${
                    mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                  }`}
                  value={idFilter}
                  onChange={(e) => setIdFilter(e.target.value)}
                  disabled={true}
                />
                <button
                  className='btn btn-icon btn-color-secondary btn-active-light-primary '
                  onClick={() => handleShowFilter('Id', 'number', 'IdReclamo')}
                >
                  <i className='bi bi-plus-circle-fill fs-1 px-2'></i>
                </button>
              </div>
            </div>

            <div className='py-0 col-3'>
              <label className='col-form-label fw-bold fs-6'>Nombres:</label>
              <div className='d-flex'>
                <input
                  type='text'
                  className={`form-control ${
                    mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                  }`}
                  value={nombreFilter}
                  onChange={(e) => setNombreFilter(e.target.value)}
                  disabled={true}
                />
                <button
                  className='btn btn-icon btn-color-secondary btn-active-light-primary '
                  onClick={() => handleShowFilter('Nombres', 'text', 'Nombres')}
                >
                  <i className='bi bi-plus-circle-fill fs-1 px-2'></i>
                </button>
              </div>
            </div>

            <div className='py-0 col-3'>
              <label className='col-form-label fw-bold fs-6'>Apellidos:</label>
              <div className='d-flex'>
                <input
                  type='text'
                  className={`form-control ${
                    mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                  }`}
                  value={apellidoFilter}
                  onChange={(e) => setApellidoFilter(e.target.value)}
                  disabled={true}
                />
                <button
                  className='btn btn-icon btn-color-secondary btn-active-light-primary'
                  onClick={() => handleShowFilter('Apellidos', 'text', 'Apellidos')}
                >
                  <i className='bi bi-plus-circle-fill fs-1 px-2'></i>
                </button>
              </div>
            </div>

            <div className='py-0 col-3'>
              <label className='col-form-label fw-bold fs-6'>Número de Documento:</label>
              <div className='d-flex'>
                <input
                  type='text'
                  className={`form-control ${
                    mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                  }`}
                  value={numeroDocumentoFilter}
                  onChange={(e) => setNumeroDocumentoFilter(e.target.value)}
                  disabled={true}
                />
                <button
                  className='btn btn-icon btn-color-secondary btn-active-light-primary '
                  onClick={() => handleShowFilter('NumeroDocumento', 'text', 'NumDocumento')}
                >
                  <i className='bi bi-plus-circle-fill fs-1 px-2'></i>
                </button>
              </div>
            </div>

            <div className='py-0 col-3'>
              <label className='col-form-label fw-bold fs-6'>Tipo de Reclamo:</label>
              <div className='d-flex'>
                <input
                  type='text'
                  className={`form-control ${
                    mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                  }`}
                  value={tipoReclamoFilter}
                  onChange={(e) => setTipoReclamoFilter(e.target.value)}
                  disabled={true}
                />
                <button
                  className='btn btn-icon btn-color-secondary btn-active-light-primary'
                  onClick={() => handleShowFilter('TipoReclamo', 'string', 'TipoReclamo')}
                >
                  <i className='bi bi-plus-circle-fill fs-1 px-2'></i>
                </button>
              </div>
            </div>

            <div className='py-0 col-3'>
              <label className='col-form-label fw-bold fs-6'>Monto de Reclamo:</label>
              <div className='d-flex'>
                <input
                  type='text'
                  className={`form-control ${
                    mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                  }`}
                  value={montoReclamoFilter}
                  onChange={(e) => setMontoReclamoFilter(e.target.value)}
                  disabled={true}
                />
                <button
                  className='btn btn-icon btn-color-secondary btn-active-light-primary '
                  onClick={() => handleShowFilter('MontoReclamo', 'text', 'MontoReclamo')}
                >
                  <i className='bi bi-plus-circle-fill fs-1 px-2'></i>
                </button>
              </div>
            </div>

            <div className='py-0 col-3'>
              <label className='col-form-label fw-bold fs-6'>Estatus:</label>
              <div className='d-flex'>
                <input
                  type='text'
                  className={`form-control ${
                    mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                  }`}
                  value={estadoFilter}
                  onChange={(e) => setEstadoFilter(e.target.value)}
                  disabled={true}
                />
                <button
                  className='btn btn-icon btn-color-secondary btn-active-light-primary '
                  onClick={() => handleShowFilter('Estatus', 'numberSelect', 'IdEstatus')}
                >
                  <i className='bi bi-plus-circle-fill fs-1 px-2'></i>
                </button>
              </div>
            </div>

            <div className='py-0 col-3'>
              <label className='col-form-label fw-bold fs-6'>Sede:</label>
              <div className='d-flex'>
                <input
                  type='text'
                  className={`form-control ${
                    mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                  }`}
                  value={sedeFilter}
                  onChange={(e) => setSedeFilter(e.target.value)}
                  disabled={true}
                />
                <button
                  className='btn btn-icon btn-color-secondary btn-active-light-primary '
                  onClick={() => handleShowFilter('Sede', 'numberSelect', 'IdOrgVxLocal')}
                >
                  <i className='bi bi-plus-circle-fill fs-1 px-2'></i>
                </button>
              </div>
            </div>

            <div className='py-0 col-3'>
              <label className='col-form-label fw-bold fs-6'>Tipo de Documento:</label>
              <div className='d-flex'>
                <input
                  type='text'
                  className={`form-control ${
                    mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                  }`}
                  value={tipoDocumentoFilter}
                  onChange={(e) => setTipoDocumentoFilter(e.target.value)}
                  disabled={true}
                />
                <button
                  className='btn btn-icon btn-color-secondary btn-active-light-primary '
                  onClick={() => handleShowFilter('Tipo de Documento', 'string', 'TipoDocumento')}
                >
                  <i className='bi bi-plus-circle-fill fs-1 px-2'></i>
                </button>
              </div>
            </div>

            <div className='py-0 col-3'>
              <label className='col-form-label fw-bold fs-6'>Tipo de Bien Contratado:</label>
              <div className='d-flex'>
                <input
                  type='text'
                  className={`form-control ${
                    mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                  }`}
                  value={tipoBienContratadoFilter}
                  onChange={(e) => setTipoBienContratadoFilter(e.target.value)}
                  disabled={true}
                />
                <button
                  className='btn btn-icon btn-color-secondary btn-active-light-primary '
                  onClick={() => handleShowFilter('Tipo de Bien Contratado', 'string', 'TipoBienContratado')}
                >
                  <i className='bi bi-plus-circle-fill fs-1 px-2'></i>
                </button>
              </div>
            </div>

            <div className='py-0 col-3'>
              <label className='col-form-label fw-bold fs-6'>Activo:</label>
              <div className='d-flex'>
                <input
                  type='text'
                  className={`form-control ${
                    mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                  }`}
                  value={activoFilter}
                  onChange={(e) => setActivoFilter(e.target.value)}
                  disabled={true}
                />
                <button
                  className='btn btn-icon btn-color-secondary btn-active-light-primary '
                  onClick={() => handleShowFilter('Activo', 'boolean', 'Activo')}
                >
                  <i className='bi bi-plus-circle-fill fs-1 px-2'></i>
                </button>
              </div>
            </div>

            {/* <div className='py-0 col-3'>
              <label className='col-form-label fw-bold fs-6'>Creado por:</label>
              <div className='d-flex'>
                <input
                  type='text'
                  className={`form-control ${
                    mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                  }`}
                  value={creadoPorFilter}
                  onChange={(e) => setCreadoPorFilter(e.target.value)}
                  disabled={true}
                />
                <button
                  className='btn btn-icon btn-color-secondary btn-active-light-primary '
                  onClick={() => handleShowFilter('Creado por', 'text', 'CreadoPor')}
                >
                  <i className='bi bi-plus-circle-fill fs-1 px-2'></i>
                </button>
              </div>
            </div> */}

            <div className='py-0 col-3'>
              <label className='col-form-label fw-bold fs-6'>Fecha de Incidencia:</label>
              <div className='d-flex'>
                <input
                  type='text'
                  className={`form-control ${
                    mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                  }`}
                  value={FechaIncidenciaFilter}
                  onChange={(e) => setFechaIncidenciaFilter(e.target.value)}
                  disabled={true}
                />
                <button
                  className='btn btn-icon btn-color-secondary btn-active-light-primary '
                  onClick={() => handleShowFilter('Fecha de Incidencia', 'date', 'FechaIncidencia')}
                >
                  <i className='bi bi-plus-circle-fill fs-1 px-2'></i>
                </button>
              </div>
            </div>

            <div className='py-0 col-3'>
              <label className='col-form-label fw-bold fs-6'>Fecha de Respuesta:</label>
              <div className='d-flex'>
                <input
                  type='text'
                  className={`form-control ${
                    mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                  }`}
                  value={FechaRespuestaFilter}
                  onChange={(e) => setFechaRespuestaFilter(e.target.value)}
                  disabled={true}
                />
                <button
                  className='btn btn-icon btn-color-secondary btn-active-light-primary '
                  onClick={() => handleShowFilter('Fecha de Respuesta', 'date', 'FechaRespuesta')}
                >
                  <i className='bi bi-plus-circle-fill fs-1 px-2'></i>
                </button>
              </div>
            </div>

            <div className='py-0 col-3'>
              <label className='col-form-label fw-bold fs-6'>Creado el:</label>
              <div className='d-flex'>
                <input
                  type='text'
                  className={`form-control ${
                    mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                  }`}
                  value={creadoElFilter}
                  onChange={(e) => setCreadoElFilter(e.target.value)}
                  disabled={true}
                />
                <button
                  className='btn btn-icon btn-color-secondary btn-active-light-primary '
                  onClick={() => handleShowFilter('Creado el', 'date', 'CreadoEl')}
                >
                  <i className='bi bi-plus-circle-fill fs-1 px-2'></i>
                </button>
              </div>
            </div>

            {/* <div className='py-0 col-3'>
              <label className='col-form-label fw-bold fs-6'>Modificado por:</label>
              <div className='d-flex'>
                <input
                  type='text'
                  className={`form-control ${
                    mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                  }`}
                  value={modificadoPorFilter}
                  onChange={(e) => setModificadoPorFilter(e.target.value)}
                  disabled={true}
                />
                <button
                  className='btn btn-icon btn-color-secondary btn-active-light-primary '
                  onClick={() => handleShowFilter('Modificado por', 'text', 'ModificadoPor')}
                >
                  <i className='bi bi-plus-circle-fill fs-1 px-2'></i>
                </button>
              </div>
            </div> */}

            <div className='py-0 col-3'>
              <label className='col-form-label fw-bold fs-6'>Modificado el:</label>
              <div className='d-flex'>
                <input
                  type='text'
                  className={`form-control ${
                    mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                  }`}
                  value={modificadoElFilter}
                  onChange={(e) => setModificadoElFilter(e.target.value)}
                  disabled={true}
                />
                <button
                  className='btn btn-icon btn-color-secondary btn-active-light-primary '
                  onClick={() => handleShowFilter('Modificado el', 'date', 'ModificadoEl')}
                >
                  <i className='bi bi-plus-circle-fill fs-1 px-2'></i>
                </button>
              </div>
            </div>
          </div>

          <div className='row mt-8'>
            <div className='py-0 col-4'>
              <div className='d-flex p-0 m-0 align-items-center'>
                <label
                  className='col-form-label fw-bold fs-6'
                  style={{width: '200px', display: 'inline-block'}}
                >
                  Cantidad Máxima:
                </label>
                <input
                  type='number'
                  className={`form-control ${
                    mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                  }`}
                  value={cantidadFilter}
                  onChange={(e) => setCantidadFilter(parseInt(e.target.value))}
                />
              </div>
            </div>

            <div className='py-0 col-5'>
              <button className='btn btn-primary  mx-1' onClick={handleFilterClick}>
                <i className='bi bi-funnel-fill px-0'> </i> Filtrar
              </button>

              <button className='btn btn-success  mx-5' onClick={limpiarFiltros}>
                <i className='bi bi-arrow-clockwise px-1'></i>Limpiar
              </button>
            </div>
          </div>

          <div className='border border-1 mt-4 mb-2'></div>
        </div>
      )}

      <FilterModal
        show={showFilter}
        handleClose={handleCloseFilter}
        tituloModal={tituloModal}
        options={options}
        tipoInput={tipoInput}
        aplicarFiltros={handleAplicarFilter}
        data={column === 'IdEstatus' ? dataEstatus : column === 'Activo' ? dataActivo : column === 'IdOrgVxLocal' ? dataOrgVXLocal :column==='TipoDocumento'?dataTipoDocumento:column==='TipoBienContratado'?dataTipoBienContratado:column==='TipoReclamo'?dataTipoReclamo:undefined}
      />

      <AdvancedTable<RegistroReclamaciones>
        data={data}
        columns={columnasReclamaciones}
        loading={loading}
        error={error}
        currentPage={page}
        totalPages={totalPages}
        onPageChange={setPage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={(val) => {
          setRowsPerPage(val)
          setPage(1)
        }}
        {...((registroFuncionalidad?.Visualizar || registroFuncionalidad?.Eliminar) && {
          showActions: true,
        })}
        {...(registroFuncionalidad?.Visualizar && {
          onView: (row: RegistroReclamaciones) => handleView(row.IdReclamo),
        })}
        {...(registroFuncionalidad?.Eliminar && {
          onDelete: (row: RegistroReclamaciones) =>
            handleDelete(row.IdReclamo, row.Nombres + ' ' + row.Apellidos),
        })}
        visibleColumnKeys={visibleColumnKeys as (keyof RegistroReclamaciones)[]}
      />
    </div>
  )
}

export {TablesReclamaciones}
